<template>
  <div class="d-flex align-center mb-2">
    <a-space>
      <a-range-picker v-model:value="daterange" :locale="locale" value-format="YYYY-MM-DD" />
      <a-select v-model:value="orgid" style="width: 150px">
        <a-select-option value="-1">全部商户</a-select-option>
        <a-select-option value="1001">南航优购</a-select-option>
        <a-select-option value="1002">银丝盾</a-select-option>
        <a-select-option value="1003">优贝克</a-select-option>
      </a-select>
      <a-input v-model:value="supplyname" placeholder="物流单号" />
      <a-button type="primary" @click="getData">查询</a-button>
    </a-space>
  </div>
  <div class="d-flex justify-space-between align-center mb-2">
    <a-space>
      <a-button type="link" @click="refresh">刷新数据</a-button>
    </a-space>
    <!-- <a-dropdown>
      <template #overlay>
        <a-menu @click="handleExportClick">
          <a-menu-item key="1" :disabled="selectedRowKeys.length === 0">导出勾选</a-menu-item>
          <a-menu-item key="2">导出所有页</a-menu-item>
        </a-menu>
      </template>
<a-button type="primary">
  导出数据
  <DownOutlined />
</a-button>
</a-dropdown> -->
  </div>
  <a-table :columns="columns" bordered :data-source="data" :loading="dataLoading" :scroll="{ x: width, y: 600 }"
    :pagination="{
      current: page,
      pageSize: limit,
      total: count,
      showQuickJumper: true,
      showSizeChanger: true,
    }" @change="(pagination) => {
      page = pagination.current;
      limit = pagination.pageSize;
    }" row-key="_id" :row-selection="{
      selectedRowKeys,
      onChange: (keys) => (selectedRowKeys = keys),
    }">
  </a-table>
</template>
<script setup>
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import { message } from "ant-design-vue";
import { ref, watch, computed, getCurrentInstance, } from "vue";
import _ from "underscore";
const { proxy } = getCurrentInstance();

const columns = [
  { title: "物流单号", dataIndex: "tracking_number", width: 150 },
  { title: "下单时间", dataIndex: "purchase_date", width: 150 },
  { title: "订单号", dataIndex: "orderid", width: 150 },
  { title: "订单金额", dataIndex: "amount", width: 100 },
  { title: "目的地国家", dataIndex: "country", width: 120 },
  { title: "币种", dataIndex: "order_currency", width: 100 },
  { title: "订单状态", dataIndex: "order_status", width: 100 },
  { title: "物流状态", dataIndex: "logistics_state", width: 150 },
  { title: "操作", dataIndex: "operation", width: 100 },
];
const daterange = ref(["", ""]);
const datetype = ref("90");
const dataLoading = ref(false);
const page = ref(1);
const limit = ref(20);
const length = ref(0);
const count = ref(0);
const data = ref([]);
const total_amount = ref(0);
const total_withdraw = ref(0);
const supplyname = ref("");
const selectedRowKeys = ref([]);
const orgid = ref("-1");

const width = computed(() => proxy.$utils.twidth(columns));

watch(() => page.value, () => {
  getData();
});
watch(() => limit.value, () => {
  if (page.value !== 1) page.value = 1;
  else getData();
});

const getData = () => {
  dataLoading.value = true;
  proxy.$api
    .doAPI("/trade/list", {
      page: page.value,
      limit: limit.value,
      daterange: daterange.value,
      datetype: datetype.value,
    })
    .then((res) => {
      dataLoading.value = false;
      if (res.code === 0) {
        data.value = _.map(res.data.list, (n) => {
          return {
            ...n,
            create_time: proxy.$dateFormat(
              n.create_time,
              "YYYY-MM-DD HH:mm"
            ),
          };
        });
        length.value = res.data.length;
        count.value = res.data.count;
        if (length.value > 0 && page.value > length.value) page.value = 1;
      } else {
        message.error(res.msg);
      }
    })
    .catch((err) => {
      dataLoading.value = false;
      console.error(err);
    });
};
const getStatistics = () => {
  proxy.$api
    .doAPI("/trade/statistics", {
      page: page.value,
      limit: limit.value,
      daterange: daterange.value,
      datetype: datetype.value,
    })
    .then((res) => {
      if (res.code === 0) {
        total_amount.value = res.data.total_amount;
        total_withdraw.value = res.data.total_withdraw;
      } else {
        message.error(res.msg);
      }
    })
    .catch((err) => {
      console.error(err);
    });
};
const handleExportClick = ({ key }) => {
  console.log("handleExportClick", key);
  switch (key) {
    case "1":
      break; //导出勾选
    case "2":
      break; //导出所有
  }
};

</script>
<style lang="less" scoped>
:deep(.ant-layout-header) {
  display: flex;
  padding: 0 20px;
}

:deep(.ant-table-thead > tr > th) {
  padding: 8px 8px !important;
}

p {
  margin: 0;
  padding: 0;
}

.static {
  padding: 20px;
  background-color: #f2f2f2;
  margin-bottom: 10px;
}
</style>